module.exports = __webpack_public_path__ + "static/media/tile-background.ede7f206.jpg";